import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import TeamCrest from "../../components/ui/TeamCrest";

// Campos compartilhados entre cadastro e edição de jogo do torneio.
const GameForm = ({ times, goleiros, values, onChange, showPhase = false }) => {
  const set = (field, transform = (v) => v) => (e) => onChange({ ...values, [field]: transform(e.target.value) });

  const teamSelect = (field, label) => (
    <TextField select fullWidth label={label} value={values[field]} onChange={set(field)}>
      {times.map((time) => (
        <MenuItem key={time._id} value={time._id}>
          <Stack direction="row" spacing={1.25} alignItems="center">
            <TeamCrest name={time.nome} size={24} />
            <span>{time.nome}</span>
          </Stack>
        </MenuItem>
      ))}
    </TextField>
  );

  const goalkeeperSelect = (field, label) => (
    <TextField select fullWidth label={label} value={values[field] || ""} onChange={set(field)}>
      <MenuItem value=""><em>Não definido</em></MenuItem>
      {goleiros.map((goleiro) => (
        <MenuItem key={goleiro} value={goleiro}>{goleiro}</MenuItem>
      ))}
    </TextField>
  );

  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>Mandante</Typography>
        <Stack spacing={2}>
          {teamSelect("time1", "Time 1")}
          {goalkeeperSelect("goleiroTime1", "Goleiro do time 1")}
          <TextField label="Gols do time 1" type="number" inputProps={{ min: 0 }} value={values.placarTime1} onChange={set("placarTime1", Number)} fullWidth />
        </Stack>
      </Grid>
      <Grid item xs={12} md={6}>
        <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>Visitante</Typography>
        <Stack spacing={2}>
          {teamSelect("time2", "Time 2")}
          {goalkeeperSelect("goleiroTime2", "Goleiro do time 2")}
          <TextField label="Gols do time 2" type="number" inputProps={{ min: 0 }} value={values.placarTime2} onChange={set("placarTime2", Number)} fullWidth />
        </Stack>
      </Grid>
      <Grid item xs={12} md={6}>
        <TextField label="Data e hora do jogo" type="datetime-local" fullWidth InputLabelProps={{ shrink: true }} value={values.dataJogo} onChange={set("dataJogo")} />
      </Grid>
      {showPhase && (
        <Grid item xs={12} md={6}>
          <Stack direction="row" spacing={2} sx={{ height: "100%" }} alignItems="center">
            <FormControlLabel control={<Switch checked={Boolean(values.isSemiFinal)} onChange={(e) => onChange({ ...values, isSemiFinal: e.target.checked, isFinal: e.target.checked ? false : values.isFinal })} />} label="Semifinal" />
            <FormControlLabel control={<Switch checked={Boolean(values.isFinal)} onChange={(e) => onChange({ ...values, isFinal: e.target.checked, isSemiFinal: e.target.checked ? false : values.isSemiFinal })} />} label="Final" />
          </Stack>
        </Grid>
      )}
    </Grid>
  );
};

export default GameForm;
